<template>
    <div class="animated fadeIn">
        <!-- Component -->
        <div class="row">
            <div class="col-sm-12">
                <b-card>
                    <div slot="header">{{ $t('Basic settings') }}</div>
                    <b-alert
                        variant="danger"
                        dismissible
                        :show="!!msg_2"
                        @dismissed="msg_2 = false"
                    >
                        <div v-html="msg_2"></div>
                    </b-alert>
                    <form @submit.prevent="save(2)">
                        <div class="form-group">
                            <label>{{ $t('email') }}</label>
                            <input
                                name="user_email"
                                v-model="record.user_email"
                                v-validate="'required|email'"
                                :class="{'form-control': true, 'is-invalid': errors.has('user_email')}"
                                type="text"
                            />
                            <span
                                v-show="errors.has('user_email')"
                                class="invalid-feedback"
                            >{{ $t(errors.first('user_email')) }}</span>
                        </div>
                        <div class="form-group">
                            <label>{{ $t('username') }}</label>
                            <input
                                name="username"
                                v-model="record.username"
                                v-validate="'required'"
                                :class="{'form-control': true, 'is-invalid': errors.has('username')}"
                                type="text"
                            />
                            <span
                                v-show="errors.has('username')"
                                class="invalid-feedback"
                            >{{ $t(errors.first('username')) }}</span>
                        </div>
                        <div class="form-group">
                            <label>{{ $t('fullname') }}</label>
                            <input
                                name="user_fullname"
                                v-model="record.user_fullname"
                                v-validate="'required'"
                                :class="{'form-control': true, 'is-invalid': errors.has('user_fullname')}"
                                type="text"
                            />
                            <span
                                v-show="errors.has('user_fullname')"
                                class="invalid-feedback"
                            >{{ $t(errors.first('user_fullname')) }}</span>
                        </div>
                        <div class="form-group">
                            <label
                                style="color: #20a8d8; text-decoration: underline;cursor: pointer;"
                                @click="avatar_modal_status = true"
                            >{{ $t('change profile photo') }}</label>
                        </div>
                        <b-card>
                            <tooltip label="mail_server_username" placement="right">
                                <input
                                    name="mail_server_username"
                                    v-model="record.mail_server_cred.mail_server_username"
                                    v-validate="'email'"
                                    :class="{'form-control': true, 'is-invalid': errors.has('mail_server_username')}"
                                    type="text"
                                />
                                <span
                                    v-show="errors.has('mail_server_username')"
                                    class="invalid-feedback"
                                >{{ $t(errors.first('mail_server_username')) }}</span>
                            </tooltip>
                            <tooltip label="mail_server_password" placement="right">
                                <input
                                    name="mail_server_password"
                                    v-model="record.mail_server_cred.mail_server_password"
                                    :class="{'form-control': true, 'is-invalid': errors.has('mail_server_password')}"
                                    type="password"
                                />
                                <span
                                    v-show="errors.has('mail_server_password')"
                                    class="invalid-feedback"
                                >{{ $t(errors.first('mail_server_password')) }}</span>
                            </tooltip>
                        </b-card>
                        <button
                            type="submit"
                            class="btn btn-square btn-info btn-md active"
                        >{{ $t('save change') }}</button>
                    </form>
                </b-card>

                <b-card>
                    <div slot="header">
                        {{ $t('customer_support_cred') }}
                        <tooltip label="customer_support_cred" placement="right" :withSlot="0" />
                    </div>
                    <b-alert
                        variant="danger"
                        dismissible
                        :show="!!msg_3"
                        @dismissed="msg_3 = false"
                    >
                        <div v-html="msg_3"></div>
                    </b-alert>
                    <form @submit.prevent="save(3)">
                        <div class="form-group">
                            <label>{{ $t('username') }}</label>
                            <input
                                name="cs_username"
                                type="text"
                                v-model="record.user_customer_support.cs_username"
                                v-validate="'required'"
                                :placeholder="$t('username')"
                                :class="{'form-control': true, 'is-invalid': errors.has('cs_username')}"
                            />
                            <span
                                v-show="errors.has('cs_username')"
                                class="invalid-feedback"
                            >{{ $t(errors.first('cs_username')) }}</span>
                        </div>
                        <div class="form-group">
                            <label>{{ $t('email') }}</label>
                            <input
                                name="cs_email"
                                v-model="record.user_customer_support.cs_email"
                                v-validate="'required|email'"
                                :class="{'form-control': true, 'is-invalid': errors.has('cs_email')}"
                                type="text"
                                :placeholder="$t('email')"
                            />
                            <span
                                v-show="errors.has('cs_email')"
                                class="invalid-feedback"
                            >{{ $t(errors.first('cs_email')) }}</span>
                        </div>
                        <div class="form-group">
                            <label>{{ $t('password') }}</label>
                            <input
                                type="password"
                                name="cs_password"
                                v-model="record.user_customer_support.cs_password"
                                v-validate="'required|min:8'"
                                :placeholder="$t('password')"
                                :class="{'form-control': true, 'is-invalid': errors.has('cs_password')}"
                            />
                            <span
                                v-show="errors.has('cs_password')"
                                class="invalid-feedback"
                            >{{ $t(errors.first('cs_password')) }}</span>
                        </div>
                        <div class="control custom-control custom-checkbox">
                            <input
                                id="customChk1"
                                type="checkbox"
                                name="cs_status"
                                class="custom-control-input"
                                v-model="record.user_customer_support.cs_status"
                                :checked="!!record.user_customer_support.cs_status"
                            />
                            <label class="custom-control-label" for="customChk1">
                                {{$t('status')}}
                                <tooltip label="status" placement="right"  :withSlot="0"/>
                            </label>
                        </div>
                        <div
                            class="form-group"
                            v-if="record.user_customer_support && record.user_customer_support.cs_info "
                        >
                            <a
                                :href="record.user_customer_support.cs_info.cs_endpoint"
                                target="_blank"
                            >
                                <em>
                                    <i class="mr-1 fa fa-link"></i>
                                    {{$t('cs_admin_panel')}}
                                </em>
                            </a>
                        </div>
                        <button
                            type="submit"
                            class="btn btn-square btn-info btn-md active"
                        >{{ $t('save change') }}</button>
                    </form>
                </b-card>

                <b-card v-if="record.user_reg_driver === 'web'">
                    <div slot="header">{{ $t('Change password') }}</div>
                    <b-alert
                        variant="danger"
                        dismissible
                        :show="!!msg_1"
                        @dismissed="msg_1 = false"
                    >
                        <div v-html="msg_1"></div>
                    </b-alert>
                    <form @submit.prevent="save(1)">
                        <div class="form-group">
                            <label>{{ $t('old password') }}</label>
                            <input
                                name="old_password"
                                type="password"
                                v-model="record.old_password"
                                v-validate="'required'"
                                :placeholder="$t('old password')"
                                :class="{'form-control': true, 'is-invalid': errors.has('old_password')}"
                            />
                            <span
                                v-show="errors.has('old_password')"
                                class="invalid-feedback"
                            >{{ $t(errors.first('old_password')) }}</span>
                        </div>
                        <div class="form-group">
                            <label>{{ $t('new password') }}</label>
                            <input
                                ref="user_password"
                                name="password"
                                type="password"
                                v-model="record.password"
                                v-validate="'required|min:6'"
                                :placeholder="$t('new password')"
                                :class="{'form-control': true, 'is-invalid': errors.has('password')}"
                            />
                            <span
                                v-show="errors.has('password')"
                                class="invalid-feedback"
                            >{{ $t(errors.first('password')) }}</span>
                        </div>
                        <div class="form-group">
                            <label>{{ $t('re new password') }}</label>
                            <input
                                name="password_confirmation"
                                type="password"
                                v-model="record.password_confirmation"
                                v-validate="'required|confirmed:user_password'"
                                :placeholder="$t('re new password')"
                                :class="{'form-control': true, 'is-invalid': errors.has('password_confirmation')}"
                            />
                            <span
                                v-show="errors.has('password_confirmation')"
                                class="invalid-feedback"
                            >{{ $t(errors.first('password_confirmation')) }}</span>
                        </div>
                        <button
                            type="submit"
                            class="btn btn-square btn-info btn-md active"
                        >{{ $t('save change') }}</button>
                    </form>
                </b-card>
            </div>
        </div>
        <!-- Modal Component -->
        <b-modal
            size="lg"
            :title="$t('Select profile photo')"
            :no-close-on-backdrop="true"
            v-model="avatar_modal_status"
            @ok="handle_avatar_modal('ok')"
            @cancel="handle_avatar_modal('cancel')"
            @hide="handle_avatar_modal('hide')"
        >
            <picture-input
                ref="avatar"
                :hideChangeButton="false"
                :removable="true"
                removeButtonClass="btn btn-pill btn-danger btn-sm active"
                accept="image/jpeg, image/png"
                buttonClass="btn btn-pill btn-info btn-sm active"
                :customStrings="custom_strings"
                @change="__test"
            ></picture-input>
        </b-modal>
    </div>
</template>
<script type="text/ecmascript-6">
import axios from 'axios'

import PictureInput from '../../components/PictureInput'
export default {
	name: 'settings',
	components: {
		PictureInput,
	},

	computed: {},

	data() {
		return {
			msg_1: false,
			msg_2: false,
			msg_3: false,
			avatar_modal_status: false,
			custom_strings: {
				upload: 'Upload it!',
				drag:
					'<small style="font-size: 70%;color: #949A9E;">' +
					this.$t('Drag and drop your image here') +
					'</small>',
			},
			record: {
				old_password: '',
				password: '',
				password_confirmation: '',
				avatar: null,
				mail_server_cred: {
					mail_server_username: null,
					mail_server_password: null,
				},
				user_email: '',
				user_fullname: '',
				user_reg_driver: '',
				username: '',
				user_customer_support: {
					cs_status: 0,
					cs_username: null,
					cs_email: null,
					cs_password: null,
				},
			},
		}
	},

	methods: {
		fetchUserProfile() {
			this.$root.loader = true
			axios.get('/user/me').then(({data}) => {
				if (data.status == 1) {
					this.$root.loader = !true
					var record = data.data
					if (!is_obj(record.mail_server_cred)) {
						record.mail_server_cred = {
							mail_server_username: null,
							mail_server_password: null,
						}
					}

					if (!is_obj(record.user_customer_support)) {
						record.user_customer_support = {
							cs_status: 0,
							cs_username: null,
							cs_email: null,
							cs_password: null,
						}
					}

					this.record = record
					this.$store.commit('set_acl', record)
				}
			})
		},

		__test(e) {
			// console.log(e)
		},

		handle_avatar_modal(mode) {
			this.avatar_modal_status = false
			switch (mode) {
				case 'ok':
					this.record.avatar =
						this.$refs.avatar && this.$refs.avatar.image.length ? this.$refs.avatar.image : null
					break
			}
			setTimeout(() => {
				this.$refs.avatar.removeImage()
			}, 0)
		},

		_get_form_fields(mode) {
			return [].concat(
				(function() {
					if (mode == 1) {
						return ['old_password', 'password', 'password_confirmation']
					} else if (mode == 2) {
						return ['user_email', 'username', 'user_fullname']
					} else if (mode == 3) {
						return ['cs_username', 'cs_email', 'cs_password']
					}
					return []
				})()
			)
		},

		save(mode = 1) {
			this.$validator.validateAll(this._get_form_fields(mode)).then((isValid) => {
				if (isValid) {
					this.$root.loader = true
					axios
						.post('/user/update_settings', {
							...this.record,
							mode,
						})
						.then((res) => {
							this.$root.loader = !true
							if (!res.data.status) {
								this['msg_' + mode] = res.data.msg
								this.$root.notify({
									message: res.data.msg ? this.$t('input validation error') : this.$t('server error'),
									status: 'error',
									autoHide: true,
									area: 'topRight',
								})
							} else {
								this['msg_' + mode] = !true
								this.$root.notify({
									message: this.$t('successfully updated'),
									status: 'success',
									area: 'topRight',
								})
								this.$store.commit('set_acl', {
									username: res.data.data.username,
									avatar: this.record.avatar || res.data.data.avatar,
									user_email: res.data.data.user_email,
									user_fullname: res.data.data.user_fullname,
									mail_server_cred: res.data.data.mail_server_cred,
									user_status: res.data.data.user_status,
								})
								if (res.data.data.user_customer_support) {
									this.$store.commit('set_acl', {
										user_customer_support: res.data.data.user_customer_support,
									})
									this.record.user_customer_support = res.data.data.user_customer_support
								}
							}
						})
						.catch((e) => {
							this.$root.loader = false
							console.warn(e)
						})
				}
			})
		},
	},
	created() {
		this.fetchUserProfile()
	},
}
</script>
